module.exports = __webpack_public_path__ + "img/bowls.e06ffb82.svg";